<template lang="pug">
  div
    v-card.round-xl.pa-4.mb-3.card-border(v-for="item in offerItems" :key="item.id" outlined @click="handleSelectedOffer(item)")
      redeem-offer-item-property(chevron-right :title="item.offer.name" :use-before="item.offer.expired_at" :redeemable-quantity="item.redeemable_qty")
</template>

<script>
import RedeemOfferItemProperty from "@/components/marketing/merchantapp/offer/RedeemOfferItemProperty.vue";

export default {
  components: {
    RedeemOfferItemProperty
  },
  props: {
    offerItems: {
      type: Array,
      default: () => ([])
    },
  },
  methods: {
    handleSelectedOffer(item) {
      this.$emit("selected", item)
    }
  },
}
</script>

<style scoped>
.card-border {
  border: 1px solid #C1C1C1 !important;
}
</style>